import { Injectable } from '@angular/core';
import { Order } from '../classes/order';
import { AuthService } from './auth.service';
import { Supplier } from '../classes/supplier';
import { IEmployee } from '../classes/IEmployee';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { EmployeeService } from './employee/employee.service';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    private siteOrders: Order[] | null = null;
    private suppliers: Supplier[] | null = null;
    private employees: IEmployee[] | null = null;

    constructor(
        private authService: AuthService,
        private router: Router,
        private employeeService: EmployeeService
    ) {
        console.log('Making a new DataService instance');
    }

    getCurrentUser(): IEmployee {
        const currentUser = this.authService.user();

        if (currentUser === null) {
            void this.router.navigateByUrl('/no-access');
            throw new Error('Current user is not available.');
        }

        return currentUser;
    }

    isCurrentUserAnAdmin(): boolean {
        return this.getCurrentUser().role === 'Admin';
    }

    getSite(): string {
        return this.getCurrentUser().site;
    }

    getSiteOrderTableName(): string {
        switch (this.getSite()) {
            case 'Flanders':
                return 'sidex-flanders-orders';
            case 'Swords':
                return 'sidex-swords-orders';
            case 'Llanberis':
                return 'sidex-llanberis-orders';
            case 'Las Angeles':
                return 'sidex-las-angeles-orders';
            default:
                throw Error('Unknown site name.');
        }
    }

    async getOrders(): Promise<Order[]> {
        return this.siteOrders;
    }

    async getSuppliers(): Promise<Supplier[]> {
        return this.suppliers;
    }

    async getEmployees(): Promise<IEmployee[]> {
        if (this.employees === null) {
            this.employees = await firstValueFrom(this.employeeService.getEmployees());
        }

        return this.employees;
    }
}
